import React, { useState, useEffect } from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { DialogTitle } from '@mui/material';
import { DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import video50 from '../../../assets/images/video50.png'
import { Button, CardMedia, DialogContent, Typography, Box } from '@mui/material';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
const getMuiTheme = () => createTheme({
  components: {}
});

function Education({ edu }) {
  const { t } = useTranslation('global');

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (<ThemeProvider theme={getMuiTheme()}>
    <Box
      sx={{
        display: 'flex',
        backgroundColor: '#f3f8fb',
        border: 'solid 1px #dcdcdc',
        borderRadius: '8px',
        margin: '15px',
        padding: '15px',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease',
        marginLeft: '40px', // Add horizontal margin
        marginRight: '40px',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.15)',
        },
      }}
      onClick={handleClickOpen}
    >
      <Box sx={{ width: '20%', display: 'flex', justifyContent: 'center' }}>
        <LibraryMusicIcon sx={{ marginRight: '8px', color: '#1976d2', fontSize: '38px' }} />
      </Box>

      <Box sx={{ width: '80%', paddingLeft: '15px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* <SchoolIcon sx={{ marginRight: '8px', color: '#1976d2', fontSize: '28px' }} /> */}
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333',fontSize: '18px' }}>
            {edu.name}
          </Typography>
        </Box>
        <Typography sx={{ marginTop: '5px', fontSize: '14px', color: '#666' }}>
          {'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s. '}
        </Typography>
      </Box>
    </Box>

    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            minWidth: "650px",
            minHeight: "200px",
            display: 'flex',
            fontFamily: 'Open Sans'
          },
          "& .MuiDialogContent-root": {
            padding: '10px'
          },
          "& .MuiDialogTitle-root": {
            padding: '10px 5px 0px 10px'
          }
        },
      }}
    >
      <DialogTitle id="alert-dialog-title"> {edu.name} </DialogTitle>
      <DialogContent>
        <CardMedia
          component='audio'
          image={`${edu.audioUrl}`}
          controls
          width={180}
          height={380}
          autoPlay
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' size='small'
          variant="contained"
          onClick={handleClose} autoFocus>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  </ThemeProvider>
  )
}

export default Education